import api from '@/api/assignments';
import store from '@/store';


const createAssignments = (context, config) => new Promise(((resolve, reject) => {
  api.createAssignments(config)
    .then((response) => {
      resolve(response);
    })
    .catch((error) => {
      reject(error);
    });
}));

const getAssignmentDetails = (context, assignmentId) => new Promise(((resolve, reject) => {
  api.getAssignmentDetails(assignmentId)
    .then((response) => {
      context.commit('SAVE_CURRENT_ASSIGNMENT_DETAILS', response);
      resolve(response);
    })
    .catch((error) => {
      reject(error);
    });
}));

const updateAssignment = (context, { assignmentId, config }) => new Promise(((resolve, reject) => {
  api.updateAssignment(assignmentId, config)
    .then((response) => {
      resolve(response);
    })
    .catch((error) => {
      reject(error);
    });
}));

const deleteAssignment = (context, assignmentId) => new Promise(((resolve, reject) => {
  api.deleteAssignment(assignmentId)
    .then((response) => {
      resolve(response);
    })
    .catch((error) => {
      reject(error);
    });
}));

const getConnectedTask = (context, lessonId) => new Promise(((resolve, reject) => {
  api.getConnectedTask(lessonId)
    .then((response) => {
      resolve(response);
    })
    .catch((error) => {
      reject(error);
    });
}));

const createGeneratedAssignment = (context, config) => new Promise(((resolve, reject) => {
  api.createGeneratedAssignment(config)
    .then((response) => {
      resolve(response);
    })
    .catch((error) => {
      reject(error);
    });
}));

const suggestVocabularyForTopics = (context, config) => new Promise(((resolve, reject) => {
  api.suggestVocabularyForTopics(config)
    .then((response) => {
      resolve(response);
    })
    .catch((error) => {
      reject(error);
    });
}));

const getAssignmentDetailsForStudent = (context, { assignmentId, studentId }) => new Promise(((resolve, reject) => {
  api.getAssignmentDetailsForStudent(assignmentId, studentId)
    .then((response) => {
      context.commit('SAVE_CURRENT_ASSIGNMENT_DETAILS', response);
      resolve(response);
    })
    .catch((error) => {
      reject(error);
    });
}));

const generateLessonForSampleTask = (context, body) => new Promise(((resolve, reject) => {
  api.generateLessonForSampleTask(body)
    .then((response) => {
      resolve(response);
    })
    .catch((error) => {
      reject(error);
    });
}));

const getAssignmentByDktId = (context, dktAssignmentId) => new Promise(((resolve, reject) => {
  api.getAssignmentByDktId(dktAssignmentId)
    .then((response) => {
      resolve(response);
    })
    .catch((error) => {
      reject(error);
    });
}));

const updateAssignmentStats = (context, assignmentIds) => new Promise(((resolve, reject) => {
  api.updateAssignmentStats(assignmentIds)
    .then((response) => {
      resolve(response);
    })
    .catch((error) => {
      reject(error);
    });
}));

export default {
  createAssignments,
  getAssignmentDetails,
  updateAssignment,
  deleteAssignment,
  getConnectedTask,
  createGeneratedAssignment,
  suggestVocabularyForTopics,
  getAssignmentDetailsForStudent,
  generateLessonForSampleTask,
  getAssignmentByDktId,
  updateAssignmentStats
};




// WEBPACK FOOTER //
// ./src/store/modules/assignments/actions.js